<template>
	<section class="events">
		<div class="container">
			<div class="row">
				<div class="offset-5 col-7">
					<a :href="`${url}api/events/favourites/pdf/`" class="filter__download"><img src="/static/img/download.svg" alt="">{{$t('pdf')}}<span class="filter__download--big">  PDF</span></a>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 col-md-3">
					<button @click="setRemind" class="events__btn" :class="{'events__btn--active': remind === 'Unremind'}">{{remind}}</button>
				</div>
				<div class="col-sm-12 col-md-3 col-3--flex">
					<span class="events__text">{{$t('events.buttons.remindInfo')}}</span>
				</div>
				<div class="col-sm-12 col-md-3">
					<button @click="getSync()" class="events__btn">{{$t('events.buttons.sync')}}</button>
				</div>
				<div class="col-sm-12 col-md-3 col-3--flex">
					<span class="events__text">{{$t('events.buttons.syncInfo')}}</span>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<div class="events__wrapper">
						<div v-for="event in events"
							 class="events__stripe-wrapper events__stripe-wrapper--desktop"
							 @click="handleEventClick($event, event.id)"
						>
							<div class="events__stripe events__stripe--short events__stripe--range"
								 :class="{'events__stripe--national': event.rank === 'national',
							 'events__stripe--international': event.rank === 'international',
							 'events__stripe--club': event.rank === 'club'}">
								<span>{{event.rank}}</span>
							</div>
							<div class="events__stripe events__stripe--short events__stripe--date">
								<span class="events__stripe--month">{{getDateRange(event.date, event.date_to)}}</span>
								<span class="events__stripe--year">{{getYear(event.date, event.date_to)}}</span>
							</div>
							<div class="events__stripe events__stripe--long events__stripe--white">
								<div class="events__stripe--location">
									<img class="events__stripe--icon" src="/static/img/mark.svg" alt="">
									<div class="events__stripe--location-wrapper">
										<span class="events__stripe--place">{{event.city.name}}</span>
										<span class="events__stripe--place">{{event.city.country.name}}</span>
									</div>
								</div>
								<span v-if="!event.distance" class="events__stripe--distance">0 km</span>
								<span v-if="event.distance" class="events__stripe--distance">{{getDistance(event.distance)}} km</span>
							</div>
							<div class="events__stripe events__stripe--long events__stripe--silver events__stripe--title-wrapper">
								<span class="events__stripe--title">{{event.name}}</span>
							</div>
							<div class="events__stripe events__stripe--long events__stripe--white events__stripe--judges-wrapper">
								<div class="events__stripe--hammer-wrapper">
									<img class="events__stripe--icon-hammer" src="/static/img/hammer.svg" alt="">
									<router-link v-if="event.judges_names[0]" :to="{name: 'JudgesList'}" class="events__stripe--btn events__judge">{{$t('events.stripes.all')}}</router-link>
								</div>
								<div class="events__stripe--judges">
									<span v-for="judge in event.judges_names" class="events__stripe--judge">{{judge}}</span>
									<router-link v-if="!event.judges_names[0]" :to="{name: 'JudgesList'}" class="events__stripe--btn events__stripe--judge events__judge">{{$t('events.stripes.judges')}}</router-link>
								</div>
							</div>
							<div @click="removeFavEvent($event, event)" class="events__stripe events__stripe--short events__stripe--fav">
								<img src="/static/img/star-gold.svg" alt="">
							</div>
						</div>


						<div
							v-for="event in events"
							class="events__stripe-wrapper events__stripe-wrapper--mobile"
							@click="handleEventClick($event, event.id)"
						>
							<div class="events__stripe events__stripe--range"
								 :class="{'events__stripe--national': event.rank === 'national',
							 'events__stripe--international': event.rank === 'international',
							 'events__stripe--club': event.rank === 'club'}">
								<span>{{event.rank}}</span>
							</div>

							<div class="events__stripe events__stripe-main">

								<div class="events__stripe events__stripe--date">
									<span class="events__stripe--month">{{getDateRange(event.date, event.date_to)}}</span>
									<span class="events__stripe--year">{{getYear(event.date, event.date_to)}}</span>
								</div>

								<div class="events__stripe events__stripe--location">
									<div>
										<img class="events__stripe--icon" src="/static/img/mark.svg" alt="">
										<span class="events__stripe--place">{{shortLocation(event.city.name)}} / {{shortLocation(event.city.country.name)}}</span>
									</div>
									<span v-if="!event.distance" class="events__stripe--distance">>>0 km</span>
									<span v-if="event.distance" class="events__stripe--distance">>>{{getDistance(event.distance)}} km</span>
								</div>


								<div class="events__stripe events__stripe--judge">
									<img class="events__stripe--icon-hammer" src="/static/img/hammer.svg" alt="">
									<div class="events__stripe--judges">
										<span v-if="event.judges_names[0]" class="events__stripe--judge">{{event.judges_names[0]}}</span>
										<router-link v-if="!event.judges_names[0]" :to="{name: 'JudgesList'}" class="events__stripe--btn events__stripe--judge events__judge">{{$t('events.stripes.judges')}}</router-link>
									</div>
								</div>

								<div class="events__stripe events__stripe--name">
									<span class="events__stripe--title">{{event.name}}</span>
								</div>


								<div v-if="$store.state.user.isLogged" @click="removeFavEvent($event, event)" class="events__stripe events__stripe--fav">
									<img v-if="event.is_favourite" src="/static/img/star-gold.svg" alt="">
									<img v-if="!event.is_favourite" src="/static/img/star-empty.svg" alt="">
								</div>
								<router-link v-if="!$store.state.user.isLogged" :to="{name: 'CreateAccount'}" class="events__stripe events__stripe--fav">
									<img src="/static/img/star-white.svg" alt="">
								</router-link>
							</div>

						</div>


					</div>
					<h3 v-if="!$store.state.myEvents.myEvents.results[0]">{{$t('noResults')}}</h3>
					<PaginationComponent :count="$store.state.myEvents.myEvents.count"
										 :currentPage="$store.state.myEvents.myEvents.currentPage"
										 @pageChanged="fetchMyEvents">
					</PaginationComponent>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import PaginationComponent from '../PaginationComponent'
	import { mapActions } from 'vuex'
	import axios from 'axios'
	export default {
		components: {
			PaginationComponent
		},
		data () {
			return {
				currentPage: 1,
				remind: '',
				url: axios.defaults.baseURL
			}
		},
		computed: {
			events () {
				const myEvents = this.$store.state.myEvents.myEvents.results
				const currentFilter = this.$store.state.myEvents.currentFilter
				return currentFilter
					? myEvents.filter(event => (
						currentFilter === 'past' ? event.is_past : !event.is_past
					))
					: myEvents
			}
		},
		methods: {
			...mapActions(['fetchMyEvents']),
			changePage (newPage) {
				this.currentPage = newPage
			},
			getDateRange (date, dateTo) {
				const [, startMonth, startDay] = date.split('-')
				const [, endMonth, endDay] = dateTo.split('-')
				const range = (startMonth !== endMonth)
					? `${ startDay }.${ startMonth }-${ endDay }.${ endMonth }`
					: `${ startDay }-${ endDay }.${ endMonth }`
				return range
			},
			getYear (date, dateTo) {
				const [startYear] = date.split('-')
				const [endYear] = dateTo.split('-')
				const year = (startYear !== endYear)
					? `${ startYear }-${ endYear }`
					: startYear
				return year
			},
			getDistance (dist) {
				return Math.round(dist)
			},
			removeFavEvent (e, event) {
				e.stopPropagation()
				axios.delete(`/api/events/favourites/${ event.id }/`, {
				})
					.then(response => {
						this.fetchMyEvents()
					})
					.catch(error => {
						console.log(error)
					})
			},
			handleEventClick (event, id) {
				if (!event.target.matches('.events__judge')) {
					this.$router.push({ name: 'Event', params: { id } })
				}
			},
			shortLocation (name) {
				const maxLength = 9
				if (name.length > 9) {
					return name.substr(0, maxLength) + '...'
				} else {
					return name
				}
			},
			getSync () {
				axios.get('/api/events/favourites/export/', {
				})
					.then(response => {
						const url = window.URL.createObjectURL(new Blob([response.data]))
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', 'sync.ics')
						document.body.appendChild(link)
						link.click()
					})
			},
			setRemind () {
				axios.post('/api/events/favourites/reminder/', {
				})
					.then(response => {
						if (response.data.is_reminder_active) {
							this.remind = this.$t('events.buttons.unremind')
						} else {
							this.remind = this.$t('events.buttons.remind')
						}
					})
			},
			getReminderStatus () {
				axios.get('/api/events/favourites/reminder/', {
				})
					.then(response => {
						if (response.data.is_reminder_active) {
							this.remind = this.$t('events.buttons.unremind')
						} else {
							this.remind = this.$t('events.buttons.remind')
						}
					})
			}
		},
		created () {
			this.fetchMyEvents()
			this.getReminderStatus()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.events {
		padding-top: 35px;
		background-color: $gray-light;
		&__btn {
			cursor: pointer;
			display: block;
			width: 100%;
			height: 50px;
			background-color: $black;
			border: none;
			font-family: $lato-bold;
			font-size: 16px;
			text-transform: uppercase;
			color: #fff;
			outline: none;
			transition: all .4s;
			&:hover {
				background-color: $gold-dark;
			}
			&--active {
				background-color: $gold-dark;
			}
		}
		&__text {
			display: block;
			font-family: $lato;
			font-size: 13px;
			color: $black;
			text-align: left;
		}
		&__wrapper {
			padding-top: 40px;
		}
		&__stripe-wrapper {
			cursor: pointer;
			display: flex;
			align-items: center;
			width: 100%;
			height: 70px;
			margin-bottom: 25px;
			a {
				text-decoration: none;
			}
			&:nth-of-type(10) {
				margin-bottom: 40px;
			}
			&--desktop {
				display: flex;
			}
			&--mobile {
				display: none;
			}
		}
		&__stripe {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			font-family: $lato;
			font-size: 16px;
			color: $black;
			&--short {
				width: 95px;
			}
			&--long {
				width: 285px;
				justify-content: space-between;
				padding: 0 15px;
			}
			&--white {
				background-color: #fff;
			}
			&--silver {
				background-color: $silver;
			}
			&--fav {
				cursor: pointer;
				background-color: $fav;
			}
			&--range {
				font-family: $lato-bold;
				font-size: 14px;
				color: #fff;
			}
			&--national {
				background-color: $national;
			}
			&--international {
				background-color: $international;
			}
			&--club {
				background-color: $club;
			}
			&--date {
				flex-flow: column;
				justify-content: center;
				align-items: center;
				background-color: $silver;
			}
			&--year {
				display: inline;
				font-family: $lato-bold;
				font-size: 13px;
				line-height: 20px;
			}
			&--location {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
			&--location-wrapper {
				display: flex;
				flex-flow: column;
				justify-content: center;
				align-items: flex-start;
			}
			&--icon {
				margin-right: 15px;
			}
			&--icon-hammer {
				margin-bottom: 5px;
			}
			&--place {
				font-size: 14px;
			}
			&--distance {
				font-size: 14px;
				font-family: $lato-bold;
				line-height: 73px;
			}
			&--title-wrapper {
				padding: 0 10px 0 15px;
			}
			&--title {
				text-align: left;
				line-height: 19px;
				font-size: 13px;
				color: $black;
			}
			&--hammer-wrapper {
				display: flex;
				flex-flow: column;
				align-items: center;
				margin-right: 15px;
			}
			&--btn {
				display: block;
				font-size: 10px;
				font-style: italic;
				text-decoration: underline !important;
				color: $black;
			}
			&--judges-wrapper {
				justify-content: flex-start;
			}
			&--judges {
				display: flex;
				flex-flow: column;
				align-items: flex-start;
			}
			&--judge {
				font-family: $lato-bold;
				font-size: 13px;
			}
		}
	}

	.filter {
		&__download {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 14px;
			text-decoration: none;
			color: $black;
			margin-bottom: 30px;
			img {
				margin-right: 15px;
			}
			&--big {
				font-family: $lato-bold;
				margin-left: 5px;
			}

			@media (min-width: 991.98px) {
				display: none;
			}
		}
	}

	.col-3 {
		&--flex {
			display: flex;
			align-items: center;
		}
	}

	@media (max-width: 991.98px) {
		.events {
			padding-top: 15px;
			&__wrapper {
				padding-top: 15px;
			}
			&__stripe-wrapper {
				align-items: center;
				width: 100%;
				height: 110px;
				margin-bottom: 25px;
				&:nth-of-type(10) {
					margin-bottom: 25px;
				}
				&--desktop {
					display: none;
				}
				&--mobile {
					display: flex;
				}
			}
			&__btn {
				margin-bottom: 15px;
			}
			&__text {
				margin-bottom: 15px;
			}
			&__stripe {
				height: 100%;
				font-size: 16px;
				&-main {
					position: relative;
					flex-flow: column;
					background: #fff;
					padding: 15px 20px 15px 10px;
					width: 95%;
				}
				&--range {
					font-size: 10px;
					width: 5%;
					span {
						line-height: 15px;
						transform: rotate(-90deg);

					}
				}
				&--date {
					flex-flow: row;
					justify-content: flex-start;
					align-items: center;
					background-color: #fff;
					width: 100%;
					color: $gold-score;
				}
				&--month {
					font-family: $lato-bold;
					font-size: 16px;
					margin-right: 5px;
				}
				&--year {
					display: block;
					font-family: $lato-bold;
					font-size: 11px;
					align-self: flex-end;
					line-height: 14px;
				}
				&--location {
					width: 100%;
					justify-content: space-between;
				}
				&--icon {
					width: 10px;
					height: 10px;
					margin-right: 5px;
				}
				&--place {
					font-family: $lato;
					font-size: 13px;
				}
				&--distance {
					line-height: normal;
				}
				&--judge {
					width: 100%;
					justify-content: flex-start;
					font-size: 13px;
					font-family: $lato;
				}
				&--icon-hammer {
					width: 10px;
					height: 10px;
					margin: 0;
					margin-right: 5px;
				}
				&--name {
					width: 100%;
					justify-content: flex-start;
				}
				&--title {
					line-height: normal;
					font-size: 10px;
				}
				&--fav {
					width: 20px;
					height: 20px;
					position: absolute;
					top: 10px;
					right: 10px;
					background: #fff;
				}
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {

	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {

	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/MyEventsList/EventsComponent.vue